import { throwError as observableThrowError, Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

export function handleCsvError(error: HttpErrorResponse): Observable<never> {
  if (error.error instanceof ErrorEvent) {
    console.error(`An error occurred:`, error.error.message);
  } else {
    console.error(`Server returned ${error.message}`);
  }

  return observableThrowError(`Unable to download csv`);
}

export function handleFileUploadError(error: HttpErrorResponse): Observable<never> {
  if (error.error instanceof ErrorEvent) {
    console.error(`An error occurred:`, error.error.message);
  } else {
    console.error(`Server returned ${error.message}`);
  }

  return observableThrowError(`Unable to upload file`);
}
